import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppConfig } from '../../../Services/app.config';
import { UsersService } from '../../../Services/users.service';
import { CheckAuth } from '../../../Services/utility.service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { UserModel } from '../../../Models/usersModel';
import { Title } from '@angular/platform-browser';
import { SessionStorageService } from 'src/common/session-storage.service';
import { AdminLoginGuard } from '../../AuthGard/AdminLoginGuard';
@Component({
  selector: 'app-admin-login',
  templateUrl: './admin-login.component.html',
  styleUrls: ['./admin-login.component.css']
})
export class AdminLoginComponent implements OnInit {
  userModel = new UserModel();
  appModel: any;
  tokenKey: string = '';
  loginForm!: FormGroup;
  isLoading:boolean=false;

  constructor(private readonly toastr: ToastrService, 
    private readonly _fb: FormBuilder, 
    private readonly UserService: UsersService, 
    private readonly router: Router,
    private readonly titleService: Title,
    private sessionStorageService: SessionStorageService,
    private readonly adminLoginGuard: AdminLoginGuard) {
    this.titleService.setTitle('Admin Login');

    if (this.redirectIfAuthenticated()) {
      return;
    }

    // setTimeout(() => {
    //   this.isLoading=false;
    // }, 2000);
  }

  private redirectIfAuthenticated(): boolean {
    try {
      const adminUserId = this.sessionStorageService.getAdminUserId();
      if (!adminUserId) {
        return false;
      }

      this.sessionStorageService.restoreAdminSessionFromLocalStorage();
      this.router.navigateByUrl(this.adminLoginGuard.consumePostLoginTarget());
      return true;
    } catch (error) {
      console.error('Admin login auth check error:', error);
      return false;
    }
  }

  ngOnInit() {
    this.appModel = AppConfig.settings.ConnectionStrings;
    this.loginForm = this._fb.group({
      userid: 0,
      username: ['', [Validators.required]],
      password: ['', [Validators.required]]
    })
  }

  CheckLogin() {

    if (this.loginForm.value["username"] == "") {
      this.showMessage('Please enter username', 'Required', 'error');
      return;
    }
    if (this.loginForm.value["password"] == "") {
      this.showMessage('Please enter password', 'Required', 'error');
      return;
    }
    if (!this.loginForm.valid) {
      return;
    }

    this.UserService.checkAdminUserLogin(this.loginForm.value.username, this.loginForm.value.password).subscribe(
      data => {
        if (data["status"] == "Success") {
          this.userModel = data["usersModel"];
          if (this.userModel != null) {

            if (data["usersModel"].listOfProducts.length > 0) {
              sessionStorage.setItem('AdminUserId', this.userModel.userId);
              sessionStorage.setItem('AdminUserType', this.userModel.userTypeId);

              localStorage.setItem('AdminUserId', this.userModel.userId);
              localStorage.setItem('AdminUserType', this.userModel.userTypeId);

              let Tool: string = data["usersModel"].listOfProducts[0].productName.toLowerCase();

              let FirstLastName = this.userModel.firstName + ' ' + this.userModel.lastName;
              if (FirstLastName.trim() != ''){
                sessionStorage.setItem('AdminFirstLastName', FirstLastName);
                localStorage.setItem('AdminFirstLastName', FirstLastName);
              }
              else{
                sessionStorage.setItem('AdminFirstLastName', this.userModel.userName);
                localStorage.setItem('AdminFirstLastName', this.userModel.userName);
              }

              sessionStorage.setItem('AdminCompanyName', this.userModel.companyName);
              localStorage.setItem('AdminCompanyName', this.userModel.companyName);

              sessionStorage.setItem('adminTypeId', this.userModel.adminTypeId.toString());
              localStorage.setItem('adminTypeId', this.userModel.adminTypeId.toString());
              localStorage.setItem('UserLoginTool', Tool);
              let UserAccessibleTools: string = ''
              
              for (let iCounter = 0; iCounter < data["usersModel"].listOfProducts.length; iCounter++) {
                UserAccessibleTools += data["usersModel"].listOfProducts[iCounter].productName + ',';
              }
              sessionStorage.setItem('UserAccessibleTools', UserAccessibleTools.substring(0, UserAccessibleTools.length - 1).toLowerCase());
              localStorage.setItem('UserAccessibleTools', UserAccessibleTools.substring(0, UserAccessibleTools.length - 1).toLowerCase());
              sessionStorage.removeItem('LoginStatus');

              // Absolute URL: relative navigate(['admin/...']) from /admin becomes
              // /admin/admin/... and hits ** → Front /login.
              // Consume returnUrl once so a stale Admin URL is not reused.
              this.router.navigateByUrl(this.adminLoginGuard.consumePostLoginTarget());
            }
            else {
              this.showMessage("You don't have access to any Tool. Please contact administrator.", 'Error', 'error');
            }
          }
        }
        else {
          this.showMessage(data["status"], 'Error', 'error');
        }
      },
      errorCode => {
        this.showMessage(errorCode, 'Error', 'error');
      }
    );

  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }
}
